// "Last heartbeat Ns ago" (UserFlows §4.2; Observability §5.6): the age counts up locally from `lastHeartbeatAt`;
// null means no `up` sample in the 48 h raw window.
import { fmtDuration } from './uptime'

/** The age part: "12s", then "5 min", "1 h 5 min". */
export function heartbeatAge(lastHeartbeatAt: string, now: number): string {
  const seconds = Math.max(0, Math.floor((now - Date.parse(lastHeartbeatAt)) / 1000))
  if (seconds < 60) return `${String(seconds)}s`
  return fmtDuration(Math.floor(seconds / 60))
}

/**
 * "Last heartbeat 12s ago"; with no heartbeat in 48 h, "Last heartbeat more than 2 days ago", or "Last heartbeat
 * never" when the clinic has no health data at all (task 11's assumption: C-12 knows from its days; the card says
 * "more than 2 days ago" whenever a connected clinic has none).
 */
export function heartbeatText(lastHeartbeatAt: string | null, now: number, never = false): string {
  if (lastHeartbeatAt === null) return never ? 'Last heartbeat never' : 'Last heartbeat more than 2 days ago'
  return `Last heartbeat ${heartbeatAge(lastHeartbeatAt, now)} ago`
}
